// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2JjhY","errorLogs":"styles_errorLogs__2steZ"};